import React, { useState, useEffect } from "react";
import Pagination from "../shared/pagination";

import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getFruitsBets } from "../originals/originals-games-api";
import { format } from "../shared/utils/dates";
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";

const UserFruitsBets = () => {
  const [data, setData] = useState({ total_pages: 0, bets: [] });
  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = useState(1);

  const { id } = useParams();

  const fetch = async () => {
    setIsLoading(true);
    try {
      const data = await getFruitsBets(id, { page });
      setData({ total_pages: data.total_pages, bets: data.records });
    } catch (err) {
      toast.error(err.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
  return (
    <div style={{ position: "relative", minHeight: 500 }}>
      {isLoading && (
        <div className={"loading-overlay"}>
          <h2>Loading, please wait ...</h2>
          <div className="loader" />
        </div>
      )}

      <Table>
        <Thead>
          <Tr>
            <Th>Bet ID</Th>
            <Th>Game Started At</Th>
            <Th>Amount</Th>
            <Th>Target Fruit</Th>
            <Th>Multiplier</Th>
            <Th>Winnings</Th>
            <Th>Fruit</Th>
            <Th>Status</Th>
            <Th>Profit</Th>
          </Tr>
        </Thead>

        <Tbody>
          {data.bets.map((b, i) => {
            const { amount, profit, multiplier, currency_type, win_amount } = b;

            return (
              <Tr key={i}>
                <Td>
                  <Link
                    to={`/casino/game-provider-rounds/${b.remote_round_id}`}
                  >
                    {b.remote_round_id}
                  </Link>
                </Td>
                <Td>{format.withSeconds(b.created_at)}</Td>
                <Td>
                  {amount} {currency_type}
                </Td>
                <Td>{b.target_fruit}</Td>
                <Td>{multiplier}</Td>
                <Td className={profit >= 0 ? "good" : ""}>
                  {win_amount > 0
                    ? `${parseFloat(win_amount).toFixed(4)} ${currency_type}`
                    : "-"}
                </Td>
                <Td>{b.fruit}</Td>
                <Td>{b.status}</Td>
                <Td className={profit >= 0 ? "good" : "bad"}>
                  {profit} {currency_type}
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <Pagination
        total_pages={data.total_pages}
        update={(page) => setPage(page)}
      />
    </div>
  );
};
export default UserFruitsBets;
